import _ from "lodash";
import React, { Fragment } from "react";
import { tick_char } from "../../components/jobBriefing/JobBrieifingReport/special-char";

export const TickBox = ({ flag, label, style, otherVal, otherStyle = {}, valAreaPostText, forceOther, skipOtherUnderline }) => {
  const isOther = ((label && label.toLowerCase() === "other") || forceOther) && !skipOtherUnderline;
  return (
    <div className="custom-tick-box" style={_.merge(isOther ? { flexGrow: 2 } : {}, style ? style : {})}>
      <span className="custom-tick-box-check"> {flag ? tick_char : ""} </span>
      <span className="custom-tick-box-label">{label}</span>
      {isOther ? (
        <Fragment>
          <span>:</span>
          <span className="text-left pd-left-10px" style={_.merge({ minWidth: "190px", borderBottom: "2px solid" }, otherStyle)}>
            {flag && otherVal ? otherVal : ""}
          </span>
          <span>{valAreaPostText}</span>
        </Fragment>
      ) : null}
    </div>
  );
};

export const SimpleTickBox = ({ flag, label, style }) => {
  return (
    <div className="custom-tick-box" style={style}>
      <span className="custom-tick-box-check"> {flag ? tick_char : ""} </span>
      <span className="custom-tick-box-label">{label}</span>
    </div>
  );
};
export const TickMark = (flag, bold) => {
  return <span className={`${bold ? "bold-text" : ""}`}>{flag ? tick_char : ""}</span>;
};

export const TickBoxOptions = (options, value) => {
  return (
    <div style={{ display: "flex" }}>
      {options.map((val, i) => (
        <div style={{ flex: 1 }}>{val === "" ? null : <TickBox key={i} flag={value === val} label={val} />}</div>
      ))}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/libraries/ReportGenerator/TickBox.jsx